import { useEffect } from 'react';

/**
 * Hook për të ndryshuar titullin e faqes dinamikisht
 * @param {string} title - Titulli i faqes (pa "| AlbMove")
 */
export const usePageTitle = (title) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} | AlbMove` : 'AlbMove | Admin Panel';
    
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export default usePageTitle;
